var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaleMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MINUS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #MINUS .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_347",
    "data-name": "Pfad 347",
    className: "cls-1",
    d: "M16,0A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14.172,14.172,0,0,1,16,30Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1542",
    "data-name": "Rechteck 1542",
    className: "cls-1",
    width: 18,
    height: 2,
    transform: "translate(6.9 15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleMinus);
export default __webpack_public_path__ + "static/media/scale-minus.4e84fb4a04bf0052c3e3322212c8bcea.svg";
export { ForwardRef as ReactComponent };